<button
  class="suggestion-card"
  type="button"
  (click)="selected.emit()"
  (keydown.enter)="selected.emit()"
  [attr.aria-label]="'Select suggestion: ' + title"
>
  <h3 class="suggestion-card__title">{{ title }}</h3>
  <p class="suggestion-card__description" *ngIf="description">{{ description }}</p>
</button>
